<template>
  <Transition>
    <AchievementModalView
      v-if="currentAchievement"
      v-model="currentAchievement"
      @close="currentAchievement = null"
    />
  </Transition>
</template>

<script lang="ts" setup>
import useFeatureFlag from "@/composables/useFeatureFlag";
import useRealtimeChannel from "@/composables/useRealtimeChannel";
import { supabaseClient } from "@/lib/database/supabase";
import useAuthStore from "@/stores/useAuthStore";
import AchievementModalView from "@/views/modals/AchievementModalView.vue";
import { Achievement, PlayerAchievement } from "@shared/lib/database/query.types";
import delay from "@shared/lib/utils/async/delay";
import { RealtimePostgresInsertPayload } from "@supabase/supabase-js";
import { storeToRefs } from "pinia";
import { ref } from "vue";

const {
  currentPlayer,
} = storeToRefs(useAuthStore());

const achievementsFlag = useFeatureFlag("achievements");

useRealtimeChannel("player_achievements", {
  handleInsert: handleAchievement,
});

const currentAchievement = ref<Achievement | null>(null);
async function handleAchievement (payload: RealtimePostgresInsertPayload<PlayerAchievement>) {
  if (achievementsFlag.value === false) return;
  if (payload.new.player_id !== currentPlayer.value?.id) return;

  const {
    data: achievement,
    error,
  } = await supabaseClient
    .from("achievements")
    .select()
    .eq("id", payload.new.achievement_id)
    .limit(1)
    .maybeSingle();

  if (error) {
    alert(error.message);
  } else {
    await delay(300);
    currentAchievement.value = achievement;
  }
}
</script>
